import { AbstractControl, ValidatorFn } from '@angular/forms';
import { PersonalCodeValidatorAbstract } from './personal-code.factory';

export class EstoniaPersonalCodeValidator implements PersonalCodeValidatorAbstract {
    public getPersonalCodeValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            const regExpOnlyNumbers = /^[0-9]+$/;

            if (!regExpOnlyNumbers.test(control.value)) {
                return { pattern: true };
            }

            if (+control.value.length !== 11) {
                return { personalCode: true };
            }

            // Validate first digit (century/gender code) - must be 1-6
            // 1-2: 1800-1899, 3-4: 1900-1999, 5-6: 2000-2099
            // odd: male, even: female
            const firstDigit = parseInt(control.value.charAt(0), 10);
            if (firstDigit < 1 || firstDigit > 6) {
                return { personalCode: true };
            }

            if (this.getControlNumber(control.value) !== parseInt(control.value.charAt(10), 10)) {
                return { personalCode: true };
            }

            const year = Number(control.value.substr(1, 2));
            const month = Number(control.value.substr(3, 2));
            const day = Number(control.value.substr(5, 2));
            const birthDate = this.getBirthday(control.value);

            if (
                year === birthDate.getFullYear() % 100 &&
                birthDate.getMonth() + 1 === month &&
                day === birthDate.getDate()
            ) {
                return null;
            } else {
                return { personalCode: true };
            }
        };
    }

    private getControlNumber(code) {
        const multiplier1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1];
        const multiplier2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3];
        let controlNumber;
        let total = 0;

        for (let i = 0; i < 10; i++) {
            total += code.charAt(i) * multiplier1[i];
        }
        controlNumber = total % 11;

        if (controlNumber < 10) {
            return controlNumber;
        }

        if (controlNumber >= 10) {
            total = 0;
            for (let i = 0; i < 10; i++) {
                total += code.charAt(i) * multiplier2[i];
            }
            controlNumber = total % 11;

            if (controlNumber < 10) {
                return controlNumber;
            } else {
                return 0;
            }
        }
    }

    private getBirthday(code) {
        let year = parseInt(code.substring(1, 3), 10);
        const month = parseInt(code.substring(3, 5).replace(/^0/, ''), 10) - 1;
        const day = code.substring(5, 7).replace(/^0/, '');
        const firstNumber = code.charAt(0);
        if (firstNumber === '1' || firstNumber === '2') {
            year += 1800;
        } else if (firstNumber === '3' || firstNumber === '4') {
            year += 1900;
        } else if (firstNumber === '5' || firstNumber === '6') {
            year += 2000;
        } else {
            year += 2100;
        }

        return new Date(year, month, day);
    }
}
